const ADJECTIVES = [
	"Solar",
	"Spicy",
	"Swift",
	"Nova",
	"Iron",
	"Silent",
	"Cosmic",
	"Crimson",
	"Golden",
	"Fierce",
	"Bright",
	"Shadow",
	"Turbo",
	"Neon",
	"Stellar",
	"Hyper",
	"Velvet",
	"Frosty",
	"Radiant",
	"Wild",
];

const OBJECTS = [
	"Cactus",
	"Comet",
	"Beacon",
	"Falcon",
	"Meteor",
	"Asteroid",
	"Rocket",
	"Circuit",
	"Harpoon",
	"Anchor",
	"Quasar",
	"Lantern",
	"Raptor",
	"Helix",
	"Citadel",
	"Blaster",
	"Vortex",
	"Sentinel",
	"Drifter",
	"Phantom",
];

export const USERNAME_PATTERN = /^[A-Za-z][A-Za-z0-9]{3,19}$/;

export const validateUsername = (value) => {
	const username = String(value || "").trim();
	if (!username) return { ok: false, reason: "Enter a username or generate one." };
	if (!USERNAME_PATTERN.test(username)) {
		return {
			ok: false,
			reason: "Use 4-20 letters or numbers, starting with a letter.",
		};
	}
	return { ok: true, username };
};

export const normalizeUsername = (value) => String(value || "").trim().toLowerCase();

const randomPart = (list) => list[Math.floor(Math.random() * list.length)];
const randomDigits = () => Math.floor(100 + Math.random() * 900);

export const generateUsernameCandidate = () => `${randomPart(ADJECTIVES)}${randomPart(OBJECTS)}${randomDigits()}`;
